function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { OvpVpiProviderInternal } from '../../video-platforms/ovp/ovp-integration-provider-internal';
import { videoPlatformIntegrationProviderFactory } from '@sky-uk-ott/core-video-sdk-js-ovp-service';
import { AsidVersion } from '../../addons/watermarking/friend-watermarking-addon/friend-watermarking.enums';
import { TestingOverrides } from '../../core/services/testing-overrides';
import { removeTrailingSlash } from '../../utils/url-remove-trailing-slash';
function buildThirdParties(addonsConfig, asidVersion) {
    var _addonsConfig_adInsertion, _addonsConfig_reporting_conviva, _addonsConfig_reporting;
    var thirdParties = new Array();
    if ((_addonsConfig_adInsertion = addonsConfig.adInsertion) === null || _addonsConfig_adInsertion === void 0 ? void 0 : _addonsConfig_adInsertion.enabled) {
        var _addonsConfig_adInsertion1, _addonsConfig_adInsertion2;
        thirdParties.push('FREEWHEEL');
        if ((_addonsConfig_adInsertion1 = addonsConfig.adInsertion) === null || _addonsConfig_adInsertion1 === void 0 ? void 0 : _addonsConfig_adInsertion1.mediaTailor) {
            thirdParties.push('MEDIATAILOR');
        }
        if ((_addonsConfig_adInsertion2 = addonsConfig.adInsertion) === null || _addonsConfig_adInsertion2 === void 0 ? void 0 : _addonsConfig_adInsertion2.yospace) {
            thirdParties.push('YOSPACE');
        }
    }
    if ((_addonsConfig_reporting = addonsConfig.reporting) === null || _addonsConfig_reporting === void 0 ? void 0 : (_addonsConfig_reporting_conviva = _addonsConfig_reporting.conviva) === null || _addonsConfig_reporting_conviva === void 0 ? void 0 : _addonsConfig_reporting_conviva.enabled) {
        thirdParties.push('CONVIVA');
    }
    switch(asidVersion){
        case AsidVersion.V3:
            thirdParties.push('FRIENDS');
            break;
        case AsidVersion.V4:
            thirdParties.push('FRV4');
            break;
        default:
    }
    return thirdParties;
}
export function loadVpiProvider(config, addonsConfig, device, asidVersion, drmOverride) {
    if (device && (config === null || config === void 0 ? void 0 : config.useCustomVpip) === false) {
        var _device_capabilities_getPlayoutCapabilities, _device_capabilities;
        var capabilities = drmOverride && drmOverride.length > 0 ? {
            default: drmOverride
        } : device === null || device === void 0 ? void 0 : (_device_capabilities_getPlayoutCapabilities = (_device_capabilities = device.capabilities).getPlayoutCapabilities) === null || _device_capabilities_getPlayoutCapabilities === void 0 ? void 0 : _device_capabilities_getPlayoutCapabilities.call(_device_capabilities);
        if ((capabilities === null || capabilities === void 0 ? void 0 : capabilities.default) && TestingOverrides.testDeviceCapabilities) {
            var _TestingOverrides_testDeviceCapabilities = TestingOverrides.testDeviceCapabilities, streamingProtocol = _TestingOverrides_testDeviceCapabilities.streamingProtocol, drmType = _TestingOverrides_testDeviceCapabilities.drmType;
            capabilities.default = capabilities === null || capabilities === void 0 ? void 0 : capabilities.default.map(function(deviceCapability) {
                return _object_spread_props(_object_spread({}, deviceCapability), {
                    transport: streamingProtocol || deviceCapability.transport,
                    protection: drmType || deviceCapability.protection
                });
            });
        }
        var _config_ovpConfig_timeouts;
        var vpipConfig = {
            capabilities: capabilities === null || capabilities === void 0 ? void 0 : capabilities.default,
            uniqueDeviceId: device === null || device === void 0 ? void 0 : device.deviceInfo.uniqueDeviceId,
            cache: {
                getValue: function(key) {
                    return device.storage.getItem(key);
                },
                setValue: function(key, value) {
                    return device.storage.setItem(key, value);
                },
                consumeValue: /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(key) {
                        return _ts_generator(this, function(_state) {
                            return [
                                2,
                                device.storage.getItem(key).then(function(value) {
                                    return device.storage.removeItem(key).then(function() {
                                        return value;
                                    });
                                })
                            ];
                        });
                    });
                    return function(key) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                deleteValue: function(key) {
                    return device.storage.removeItem(key);
                }
            },
            authIssuer: config.ovpConfig.authIssuer,
            endpoints: {
                get ovpHostname () {
                    return removeTrailingSlash(config.ovpConfig.ovpHostname);
                },
                get playback () {
                    var ovpHostname = removeTrailingSlash(config.ovpConfig.ovpHostname);
                    return {
                        getEventAsset: "".concat(ovpHostname, "/video/playouts/event"),
                        getLiveContent: "".concat(ovpHostname, "/video/playouts/live"),
                        getShortformAsset: "".concat(ovpHostname, "/play-preview/playouts/vod"),
                        getVODAsset: "".concat(ovpHostname, "/video/playouts/vod")
                    };
                }
            },
            timeouts: (_config_ovpConfig_timeouts = config.ovpConfig.timeouts) !== null && _config_ovpConfig_timeouts !== void 0 ? _config_ovpConfig_timeouts : [
                2e4,
                3e4
            ],
            thirdParties: buildThirdParties(addonsConfig, asidVersion),
            ovpHeaders: {
                device: config.ovpConfig.device,
                platform: config.ovpConfig.platform,
                get proposition () {
                    return config.ovpConfig.proposition;
                },
                get provider () {
                    return config.ovpConfig.provider;
                },
                get territory () {
                    return config.ovpConfig.territory;
                },
                get broadcastRegions () {
                    return config.ovpConfig.broadcastRegions;
                }
            },
            activeTerritory: config.ovpConfig.activeTerritory,
            customHeaders: config.ovpConfig.customHeaders,
            getAccountHolder: config.ovpConfig.getAccountHolder,
            getActiveProfile: config.ovpConfig.getActiveProfile,
            pinOverride: config.ovpConfig.pinOverride,
            language: config.ovpConfig.language,
            postalCode: config.ovpConfig.postalCode,
            countryCode: config.ovpConfig.countryCode
        };
        return videoPlatformIntegrationProviderFactory(vpipConfig, config.tokenService, config.signatureHandler);
    }
    return (config === null || config === void 0 ? void 0 : config.useCustomVpip) ? undefined : new OvpVpiProviderInternal();
}

//# sourceMappingURL=video-platform-integration-provider-factory.js.map